import React from 'react';
import { Redirect } from 'react-router-dom';

import routes from '../../constants/routes'

export class ExternalLogin extends React.Component {
    render() {
        return <Redirect to={routes.LOGIN} />;
    }
}

export default ExternalLogin;
